const s = {
  egfkug7vk6: { class: "aaoa", name: "AAOA" },
  uc4whhn8ih: { class: "arag", name: "ARAG" },
  bnitnlkzp8: { class: "assistenza", name: "Assistenza" },
  "5qfhomoofb": { class: "connected-investors", name: "Connected Investors" },
  jbsr7tga1f: { class: "honcho", name: "Honcho" }
};
export {
  s as AFFILIATE_MAPPING
};
//# sourceMappingURL=index3.js.map
